export const overlays = {
  light: {
    '75': 'rgba(255, 255, 255, 0.75)',
    '50': 'rgba(255, 255, 255, 0.50)',
    '25': 'rgba(255, 255, 255, 0.25)',
    '10': 'rgba(255, 255, 255, 0.10)',
    '5': 'rgba(255, 255, 255, 0.05)',
  },
  dark: {
    '75': 'rgba(0,0,0, 0.75)',
    '50': 'rgba(0,0,0, 0.50)',
    '25': 'rgba(0,0,0, 0.25)',
    '10': 'rgba(0,0,0, 0.10)',
    '5': 'rgba(0,0,0, 0.05)',
  },
} as const;
